import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import { i18n } from "./setups/i18n"
import globalComponentsRegistration from "./setups/globalComponentsRegistration.js"
import directivesRegistration from "./setups/directivesRegistration.js"
import pluginsRegistration from "./setups/pluginsRegistration.js"
import themeRegistration from "./setups/themeRegistration.js"
import "./assets/css/studioTailwind/index.css"
import "./assets/css/studioTailwind/animate.css"
import { initApp } from "./middlewares/initApp"

// Setup
themeRegistration()
globalComponentsRegistration()
directivesRegistration()
pluginsRegistration()

Vue.config.productionTip = false

// vue-router 3 runs its initial navigation (and therefore beforeEach) inside
// `new Vue({ router })`, so window.envConfig must exist before this line or the auth
// guard sees cookie mode as off and bounces every full page load to /login.
initApp()

const app = new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
})

app.$mount("#app")
